import React from 'react';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import type { DecisionMaker } from 'src/app/pages/petitionDetails/shared/types';

import type { AllDmResponses } from '../../../../hooks/useDecisionMakerCards';
import { useDmResponse } from '../../shared/hooks/useDmResponse';

type DmResponseProps = {
	decisionMaker: DecisionMaker;
	allDmResponses: AllDmResponses;
};

export function ReadDmResponse({ decisionMaker, allDmResponses }: DmResponseProps): React.JSX.Element | null {
	const {
		data: { dmHasResponded, firstDmResponseUrl },
		actions: { handleReadResponseClick },
	} = useDmResponse({ decisionMaker, allDmResponses });

	const { translate } = useI18n();
	const isSunriseThemeEnabled = useIsSunriseTheme();

	return (
		<>
			{dmHasResponded && (
				<ButtonLink
					to={firstDmResponseUrl}
					aria-label={translate('corgi.petition_gamma.decision_makers.read_response')}
					target="blank"
					data-testid="read-dm-response"
					data-qa="read-dm-response"
					variant={isSunriseThemeEnabled ? 'secondary' : 'secondaryEmphasis'}
					sx={{ width: '100%' }}
					onClick={handleReadResponseClick}
				>
					<Translate value="corgi.petition_gamma.decision_makers.read_response" />
				</ButtonLink>
			)}
		</>
	);
}
